import { render, staticRenderFns } from "./file-picker.vue?vue&type=template&id=8d04fd7e&scoped=true"
import script from "./file-picker.vue?vue&type=script&lang=js"
export * from "./file-picker.vue?vue&type=script&lang=js"
import style0 from "./file-picker.vue?vue&type=style&index=0&id=8d04fd7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d04fd7e",
  null
  
)

export default component.exports